import ES from './es';
import EN from './en';

const fileUploader = {
    ES,
    EN
};

export default fileUploader;
